import $ from 'jquery'

export default {
	name: 'importer-medicament',
	components: {},
	props: {
		type_article: String
	},
	data() {
		return {
			files: [],
			is_loading: false,
			is_error: false
		}
	},
	computed: {

	},
	mounted() {

	},
	methods: {
		handleFilesUpload() {
			$('.err-msg').fadeOut()
			let uploadedFiles = this.$refs.files.files;
			/*
			  Adds the uploaded file to the files array
			*/
			this.files = []
			for (var i = 0; i < uploadedFiles.length; i++) {
				this.files.push(uploadedFiles[i]);
			}
		},


		importMedicament() {
			this.is_loading = true

			let formData = new FormData();
			$('.err-msg').fadeOut()
			this.is_error = false

			let err = 0

			if (this.files.length == 0) {
				err++
			}

			if (err == 0) {
				formData.append('file', this.files[0]);

				const dispatch_action = (this.type_article == '1')?'importMedicament':'importConsommable'
				this.$store.dispatch(dispatch_action, { 'data': formData }).then(() => {
					this.is_loading = false
					// après le rendu sur la page, faire disparaitre le modal
					this.files = []
					var preview = document.getElementById('files');
					preview.value = "";

					this.$refs.close_modal.click()

					if (this.type_article == '1') {
						this.successToast("Importation des médicaments avec succès");
						this.$emit("emitListMedicament")
					} else {
						this.successToast("Importation des consommables avec succès");
						this.$emit("emitListConsommable")
					}
					

				}).catch(() => {
					this.is_error = true
					this.is_loading = false
				})
			} else {
				// Afficher un message informant l'utilisateur de choisir un fichier
				$('.err-msg').fadeIn(500)
				this.is_loading = false
			}
		},
	}
}


